import { getYearMonth } from '../../helper';

export const getInitialState = (urlParams) => ({
  currentStep: 1,
  selectedPlan: null,
  arenaName: '',
  passList: [],
  originalPassList: [],
  loading: true,
  error: '',
  showTemplate: null,
  visible: urlParams.get('visible'),
  parkingId: null,
  timeZone: '',
  no_of_spots: 1,
  monthlyAccountPrice: null,
  rentalFee: null,
  convFee: null,
  reservedSpot: null,
  isPayment: false,
  terms: [],
  loadingPricing: false,
  submittingForm: false,
  isAutoApproval: false,
  lotType: '',
  isEnforcement: false,
  customerData: null,
  customerRequest: null,
  booked: false,
  subscriptionData: null,
  subscriptionId: null,
  subscriptionType: null,
  pendingRequest: null,
  is45SECase: false,
  is207CollegeSt: false,
  is700BiscayneLot: false,
  individualFields: {
    first_name: '',
    last_name: '',
    areaCode: 1,
    phone1: '',
    email: '',
    unit_number: '',
    vehicle_no: '',
    vehicle_make: '',
    vehicle_model: '',
    vehicle_color: ''
  },
  alternateVehicles: [],
  individualValidity: null,
  individualErrors: {},
  showCarMakeModal: false,
  showCarColorModal: false,
  showAlternateCarMakeModal: false,
  showAlternateCarColorModal: false,
  currentAlternateIndex: null,
  accountFields: {
    company_name: '',
    first_name: '',
    last_name: '',
    areaCode: 1,
    phone1: '',
    admin_email: ''
  },
  members: [],
  accountValidity: null,
  accountErrors: {},
  minMembers: 5,
  showAccountCarMakeModal: false,
  showAccountCarColorModal: false,
  currentMemberIndex: null,
  currentAccountAlternateIndex: null
});

export const initializePlanState = (plan, parkingId) => {
  const subscriptionType = plan?.subscriptionType || 'individual';
  const minMembers = plan?.pricing_data?.min_allowed_users || 5;
  
  let validity = getYearMonth();
  if (parkingId === 6029) {
    validity = getYearMonth({ year: 2025, month: 7 });
  }
  
  let members = [];
  if (subscriptionType === 'account') {
    for (let i = 0; i < minMembers; i++) {
      members.push({
        first_name: '',
        last_name: '',
        areaCode: 1,
        phone1: '',
        email: '',
        vehicle_no: '',
        vehicle_make: '',
        vehicle_model: '',
        vehicle_color: '',
        alternate_vehicles: []
      });
    }
  }
  
  return {
    selectedPlan: plan,
    subscriptionType: subscriptionType,
    individualValidity: validity,
    accountValidity: validity,
    members: members,
    minMembers: minMembers
  };
};

